export default function TermsOfServiceRoute() {
	return (
		<div className="container mx-auto px-4 py-12">
			<h1 className="mb-8 text-3xl font-bold">Terms of Service</h1>

			<div className="prose prose-slate max-w-none">
				<h2 className="mb-4 mt-6 text-xl font-semibold">
					1. Acceptance of Terms
				</h2>
				<p className="mb-4">
					By accessing and using InSelect ("the Service"), you agree to be bound
					by these Terms of Service. If you do not agree to these terms, please
					do not use the Service.
				</p>

				<h2 className="mb-4 mt-6 text-xl font-semibold">
					2. Description of Service
				</h2>
				<p className="mb-4">
					InSelect is an AI-powered caption generation service for Instagram
					content. We provide tools and features to help users create engaging
					and personalized captions for their Instagram posts.
				</p>

				<h2 className="mb-4 mt-6 text-xl font-semibold">
					3. User Responsibilities
				</h2>
				<p className="mb-4">
					You are responsible for maintaining the confidentiality of your
					account information and for all activities that occur under your
					account. You agree to notify us immediately of any unauthorized use of
					your account.
				</p>

				<h2 className="mb-4 mt-6 text-xl font-semibold">
					4. Content Guidelines
				</h2>
				<p className="mb-4">Users must not generate or use content that:</p>
				<ul className="mb-4 ml-6 list-disc">
					<li>Violates any applicable laws or regulations</li>
					<li>Infringes on intellectual property rights</li>
					<li>Contains harmful or malicious content</li>
					<li>Promotes hate speech or discrimination</li>
				</ul>

				<h2 className="mb-4 mt-6 text-xl font-semibold">
					5. Service Modifications
				</h2>
				<p className="mb-4">
					We reserve the right to modify or discontinue the Service at any time,
					with or without notice. We shall not be liable to you or any third
					party for any modification, suspension, or discontinuance of the
					Service.
				</p>

				<h2 className="mb-4 mt-6 text-xl font-semibold">
					6. Contact Information
				</h2>
				<p className="mb-4">
					If you have any questions about these Terms of Service, please contact
					us at hello@inselect.app.
				</p>
			</div>
		</div>
	)
}
